import { useState, useEffect } from "react";
import axios from "axios";
import { devURL } from "../constants/constants";
import Loading from "../components/global/Loading";
import StationWidgets from "../components/sales_all/StationWidgets";
import HeadingDiagrams from "../components/homepage/HeadingDiagrams";
import Diagrams from "../components/homepage/Diagrams";
import '../styles/homepage.css';
import '../styles/sales-all.css';

export default function SalesAll() {
  const [ data, setData ] = useState(null);
  
  useEffect( () => {
    async function getData() {
      try {
        const date = new Date();
        const today = `${date.getFullYear()}-${(date.getMonth() + 1) < 10 ? ('0' + (date.getMonth() + 1)) : date.getMonth() + 1}-${date.getDate() < 10 ? ('0' + date.getDate()) : date.getDate()}`
        await axios({
          method: 'get',
          url: `${devURL}/live-sales?station=AX001&station=AX002&station=AX003&date=${today}`
        }).then(response => setData(response.data))
      } catch(error) {
        console.log(error)
      }
    };
    getData();
  }, [] );


  let all = {
    basket: 0,
    clients: 0,
    margin: 0,
    netto: 0,
    volume: 0,
    comp_basket: 0,
    comp_clients: 0,
    comp_margin: 0,
    comp_volume: 0,
    comp_netto: 0,
    products: {
      4243: { volume: 0, netto: 0 },
      4241: { volume: 0, netto: 0 },
      4244: { volume: 0, netto: 0 },
      4242: { volume: 0, netto: 0 },
      9521: { volume: 0, netto: 0 },
      4245: { volume: 0, netto: 0 }
    }
  };
  for(const i in data) {
      all.basket += data[i].today.total.basket;
      all.clients += data[i].today.total.clients;
      all.margin += data[i].today.total.margin;
      all.netto += data[i].today.total.netto;
      all.volume += data[i].today.total.volume;
      all.comp_basket += data[i].compare.basket.percent;
      all.comp_clients += data[i].compare.clients.percent;
      all.comp_netto += data[i].compare.netto.percent;
      all.comp_volume += data[i].compare.volume.percent;
      all.comp_margin += data[i].compare.margin.percent;
  };
  all.basket = all.basket / 3;
  all.comp_basket = all.comp_basket / 3;
  all.comp_clients = all.comp_clients / 3;
  all.comp_netto = all.comp_netto / 3;
  all.comp_volume = all.comp_volume / 3;
  all.comp_margin = all.comp_margin / 3;

  return (
    <>
      <h1 className="sales-heading"><span className="live-dot"></span>LIVE raport sprzedaży - wszystkie stacje</h1>
      {!data ? <Loading/> : <StationWidgets data={data}/>}
      {!data ? <Loading/> : <HeadingDiagrams data={all}/>}
      {!data ? <Loading/> : <Diagrams data={data}/>}
    </>
  )

};